import {getPassVerifCode, signIn} from "@/api/auth";
import Button from "@/components/buttons";
import Input from "@/components/form-components";
import React, {useContext, useState} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import LoaderLayout from "@/components/LoaderLayout";
import {toast} from "react-toastify";
import {Context} from "@/components/utils";
import {SET_AUTH_STEP, SET_USER} from "@/controllers/actions";
import PasswordInput from "@/components/form-components/PasswordInput";
import {normalizeErrorFields} from "@/functions/validation";

export default function SignIn() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {
        state: {user},
        dispatch,
    } = useContext(Context);

    const {
        register,
        clearErrors,
        setError,
        watch,
        handleSubmit,
        formState: {errors},
    } = useForm({defaultValues: user});

    const [loading, setLoading] = useState(false);

    const submit = async (values: any) => {
        setLoading(true);
        try {
            const {data} = await signIn(values);
            localStorage.setItem("token", data.access_token);
            toast.success(t("successfully_signin"));
            navigate("/profile");
        } catch (error: any) {
            console.log(error);
            if (error?.response?.status === 422) {
                normalizeErrorFields(error?.response?.data, setError);
            } else if (error?.response?.status === 401) {
                setError('password', {
                    type: 'server',
                    message: t('incorrect_login_password')
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const forgotPass = async () => {
        const phoneNumber = watch("phone");
        if (!phoneNumber) {
            return setError("phone", {
                type: "required",
                message: t("required"),
            });
        }
        clearErrors("phone");
        try {
            await getPassVerifCode({phone: phoneNumber});
            dispatch({type: SET_USER, payload: {phone: phoneNumber}});
            dispatch({
                type: SET_AUTH_STEP,
                payload: {prevStep: 1, currentStep: 100},
            });
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="login-side">
            <form className="form">
                <Input
                    parentClass="d-flex flex-column"
                    register={register}
                    name="phone"
                    type="tel"
                    errors={errors}
                    validations={{required: t("required")}}
                    label={t("phone_number")}
                    placeholder="+998"
                    inputClass="natural-6-border text-bold natural-2"
                    labelClass="size-7 natural-5 text-medium m-0"
                />
                <PasswordInput
                    parentClass="d-flex flex-column"
                    register={register}
                    name="password"
                    errors={errors}
                    validations={{required: t("required")}}
                    label={t("password")}
                    inputClass="natural-6-border text-bold natural-2"
                    labelClass="size-7 natural-5 text-medium m-0"
                />
            </form>
            <div className="bottom-side d-flex-center justify-content-between">
                <Button className="forgot-btn primary-1" onClick={forgotPass}>
                    {t("forgot_password")}
                </Button>
                <Button
                    className="submit-btn primary-1-bg natural-8 size-7"
                    onClick={handleSubmit(submit)}
                >
                    {t("sign_in")}
                    <LoaderLayout
                        loading={loading}
                        style={{width: "16px", marginRight: "12px"}}
                        children={
                            <img src="/icons/arrow-left.svg" width={16} alt="arrow"/>
                        }
                    />
                </Button>
            </div>
        </div>
    );
}
